<template>
  <el-dialog title="隱私權聲明" :visible.sync="policyVisible" width="600px" fullscreen>
    <div class="policy-dialog-content">
      <div
        class="subtitle"
      >非常歡迎您光臨「Lets Movie」（以下簡稱本網站），為了讓您能夠安心使用本網站的各項服務與資訊，特此向您說明本網站的隱私權保護政策，以保障您的權益，請您詳閱下列內容：</div>
      <h3>一、隱私權保護政策的適用範圍</h3>

      <p>隱私權保護政策內容，包括本網站如何處理在您使用網站服務時收集到的個人識別資料。隱私權保護政策不適用於本網站以外的相關連結網站，也不適用於非本網站所委託或參與管理的人員。</p>

      <h3>二、個人資料的蒐集、處理及利用方式</h3>

      <ul>
        <li>
          當您造訪本網站或使用本網站所提供之功能服務時，
          我們將視該服務功能性質，請您提供必要的個人資料，
          並在該特定目的範圍內處理及利用您的個人資料；非經您書面同意，
          本網站不會將個人資料用於其他用途。
        </li>
        <li>本網站在您使用服務信箱、問卷調查等互動性功能時，會保留您所提供的姓名、電子郵件地址、聯絡方式及使用時間等。</li>
        <li>
          於一般瀏覽時，伺服器會自行記錄相關行徑，
          包括您使用連線設備的IP位址、使用時間、使用的瀏覽器、瀏覽及點選資料記錄等，做為我們增進網站服務的參考依據，此記錄為內部應用，決不對外公佈。
        </li>
        <li>為提供精確的服務，我們會將收集的問卷調查內容進行統計與分析，分析結果之統計數據或說明文字呈現，除供內部研究外，我們會視需要公佈統計數據及說明文字，但不涉及特定個人之資料。</li>
      </ul>

      <h3>三、資料之保護</h3>

      <ul>
        <li>
          本網站主機均設有防火牆、防毒系統等相關的各項資訊安全設備及必要的安全防護措施，
          加以保護網站及您的個人資料採用嚴格的保護措施， 只由經過授權的人員才能接觸您的個人資料，
          相關處理人員皆簽有保密合約，如有違反保密義務者， 將會受到相關的法律處分。
        </li>
        <li>如因業務需要有必要委託其他單位提供服務時，本網站亦會嚴格要求其遵守保密義務，並且採取必要檢查程序以確定其將確實遵守。</li>
      </ul>

      <h3>四、網站對外的相關連結</h3>

      <p>本網站的網頁提供其他網站的網路連結，您也可經由本網站所提供的連結，點選進入其他網站。但該連結網站不適用本網站的隱私權保護政策，您必須參考該連結網站中的隱私權保護政策。</p>

      <h3>五、與第三人共用個人資料之政策</h3>

      <p>本網站絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關，但有法律依據或合約義務者，不在此限。</p>

      <p>前項但書之情形包括不限於：</p>

      <ul>
        <li>經由您書面同意。</li>
        <li>法律明文規定。</li>
        <li>為免除您生命、身體、自由或財產上之危險。</li>
        <li>與公務機關或學術研究機構合作，基於公共利益為統計或學術研究而有必要，且資料經過提供者處理或蒐集著依其揭露方式無從識別特定之當事人。</li>
        <li>當您在網站的行為，違反服務條款或可能損害或妨礙網站與其他使用者權益或導致任何人遭受損害時，經網站管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。</li>
        <li>有利於您的權益。</li>
        <li>本網站委託廠商協助蒐集、處理或利用您的個人資料時，將對委外廠商或個人善盡監督管理之責。</li>
      </ul>

      <h3>六、Cookie之使用</h3>

      <p>
        為了提供您最佳的服務， 本網站會在您的電腦中放置並取用我們的Cookie，
        若您不願接受Cookie的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，即可拒絕Cookie的寫入，但可能會導至網站某些功能無法正常執行
        。
      </p>

      <h3>七、服務使用協議</h3>
      <div style="text-align:left;">
        <p>第一條[會員註冊]</p>用戶同意本使用協議所規定之註冊方式，並通過審核後，方可使用本服務。
        <br />
        <p>第二條[會員資格]</p>會員需符合以下所有條件，才是本公司所認可之會員。
        <br />1. （1）年滿18歲之單身者（單身係指：無法定婚姻關係配偶者）
        <br />2. （2）有本人名義的Facebook帳戶。
        <br />3. （3）該人士並非本公司認定之不提供服務之對象(黑名單)。
        <br />
        <p>第三條[費用規定]</p>1. 1. 凡用戶已同意參與者，應負有支付活動，及其他本公司或本公司的業務合作公司所提供之服務媒合費的義務。
        <br />2. 2. 服務內容之通知將以網頁登載或其他本公司認可之適當方式通知用戶。
        <br />3. 3. 本服務所舉辦之活動因不可歸責本公司之原因停止或中斷時，用戶不得以此為理由，進行任何退還、減少費用或請求損害賠償；但若可歸責於因參加人數不足，本公司判斷停止舉辦活動時，本公司會退還參加者已支付之媒合費用。
        <br />4. 4. 用戶如有違反本服務條款或不可歸責於本公司之情事致接受停止使用之處分或通知時，已發生或應支付之費用仍應照常給付。
        <br />5. 5. 點數一經購買，除本使用條款另有規定者外，不得退費。活動方案所贈送的點數，經使用後，若需退費者將先扣除贈送點數後依規約進行退費。若您的手機、信用卡、虛擬加值帳戶等加值工具被盜用，需提供相關第三方證明，例如報案三聯單、刷卡行該卡號停用通知函等等文件，本站才有權依法進行退費及停用本站帳號等後續程序。 若您欲終止本合約及申請退費時，應依照本站規定之流程辦理, 本站將扣除必要成本(包括但不限於購買與退還時之金流廠商的代收費用及人工處理費等)及20 ％手續費後，於退費手續申辦完成"並收到金流公司帳務處理完成通知"後三十日內，將剩餘款項退還給您。 如退費之金額低於相關匯款之手續費者，您須請親洽本公司領取。 每位消費者以及每一帳號限退費乙次。
        <br />
        <p>第四條[約會守則]</p>用戶參加本公司Bot配對服務，需遵守下列條款：
        <br />1. 1. 不能在約會前詢問聯絡方式，約會時方可詢問對方社群等聯絡方式。
        <br />2. 2. 因天災等不得抗力之原因中止活動時，不收取取消之成本費用。
        <br />3. 3. 參加者經常無故取消、或其餘造成本公司服務不合，本公司有權列入黑名單，黑名單者今後不得參加本公司任何活動（不會另行通知）。
        <br />4. 我們的服務為電影約會，如除了電影約會外，其餘約會（不論額外約吃飯，給對方載）皆是本公司不負任何責任，請使用者在首次約會僅電影約會，別去答應對方的任何邀約，當熟時再下次另行邀約。
        <br />5. 電影邀約時，如對方產生不良舉動，請密粉絲專頁，我們將會協助你做後續處理。
        <br />6. 電影約會的媒合，將會在Bot上執行。
        <br />
        <p>第五條[禁止事項]</p>會員不得從事下列項目或可能適用於使用本服務的下列項目的行為。
        <br />1. (1)故意登記錯誤或虛假資訊，或冒充他人。
        <br />2. (2)使用此服務進行非尋找交友之其他目的或行為。
        <br />3. (3)已有婚約或已婚仍利用本服務。
        <br />4. (4)引誘兒童進行買春，賣春，援交，或相關行為。
        <br />5. (5)直接或間接，與被拒絕交往的對方聯繫。
        <br />6. (6)任何歧視，欺凌或誣告，或對其他會員，本公司或第三方損害他人名譽的行為。
        <br />7. (7)竄改，刪除，任意洩露，引用予第三者透過使用本服務得到之資訊。
        <br />8. (8)侵害本公司或第三方的著作權，商標等智慧財產權，隱私或肖像權。
        <br />9. (9)延遲或拒絕支付使用費。
        <br />10. (10)本公司判斷難以提供本服務之用戶。
        <br />11. (11)公開不遵守本服務使用協議。
        <br />12. (12)違反Facebook的使用條款。
        <br />13. (13)阻礙本服務或本公司之業務運作的任何行為。
        <br />14. (14)不得違反本服務使用協議，法律及其他善良風俗。
        <br />
        <p>第六條[著作權]</p>揭載本公司服務之網頁，或各內容供應商之版權和其他智慧財產權屬於本公司與其他內容供應商所有。會員未經事先許可不得自行以重製、編輯、改作、公開傳輸或公開散佈之方式作為商業或非商業性的使用。會員上傳之文圖、影音應屬合法取得授權或擁有智慧財產權之物，如經他人檢舉或主張時，本公司有權下架、封鎖或刪除該文圖，會員應自負侵權責任，概與本公司無涉。
        <br />
        <p>第七條[強制退會]</p>會員發生以下狀況時，本公司可立即強制要求退會。該會員不能要求賠償因強制退出而造成的任何形式的損失。
        <br />1. (1)違反本協議或被視為可能違反本協議。
        <br />2. (2)該會員的死亡。
        <br />3. (3)判定為無會員資格時。
        <br />4. (4)在一定時間無登入動作，且對於本公司之通知無任何回應。
        <br />5. (5)延遲或不支付費用時。
        <br />6. (6)已被強制退會或使用停止處分之後再次申請時。
        <br />7. (7)其他本公司認定為會影響本服務提供時。
        <br />
        <p>第八條[免責聲明]</p>1. 1. 本公司除非因故意或重大過失以外之行為，本公司對於以下之狀況不承擔任何責任。
        <br />* (1)關於與本公司向用戶提供的本服務相關的數據的完整性、正確性、合法性、有用性等。
        <br />* (2)資訊的消失（不包括由個人自行刪除），以及因無法使用本服務而造成的損失。
        <br />* (3)因使用本服務造成會員的個人電腦中毒。
        <br />* (4)因使用本服務造成會員與其他會員的糾紛及損害。
        <br />* (5)本服務的中斷或中止。
        <br />* (6)由於用戶沒有閱讀本服務使用協議而產生的損失。
        <br />* (7)本公司對用戶的通知、聯絡等的延誤或沒到。
        <br />2. 2. 本公司僅對該用戶真實發生的一般損害內負責，且其總額不得超出損害發生日當月本公司應從該用戶收到的的使用費。
        <br />3. 約會時發生的意外，如因為場地環境問題，由當時場地主承擔責任，如為約會對象造成的法律責任，由對方承擔法律責任，而我們會協助處理後續事項。
        <br />
        <p>第九條[中斷，變更，停止]</p>本公司發生下列事項中任一項目時，可中斷，變更，停止或取消本服務，原則上會預先刊登於公開可視之網站或傳媒中作為通知，但在緊急情況可能無法進行預先告知。
        <br />1. (1)本服務之系統定期或緊急維修。
        <br />2. (2)電信服務業者暫停提供電信服務。
        <br />3. (3)火災，停電或天災或其他不可歸責於其他企業之責，造成本服務無法繼續提供時，其他本公司判定需中斷，變更，停止提供服務時。
        4. (4)由於執行或技術上的原因，需暫時中斷時。
        <br />5. (5)行政或其他原因下令本服務必須中斷，變更，停止。
        <br />
        <p>第十條[損害賠償]</p>會員違反本協議，造成本公司之損失時，本公司可要求該會員賠償（包括但不限於訴訟費及律師費）。
        <br />
        <p>第十一條[本協議的修改]</p>本公司可以隨時修改，追加本服務協議之相關條文，並以本公司指定的方法通知各會員。修改內容於公布於本網站時即生效力。
        <br />
        <p>第十二條[準據法]</p>本協議未盡之事項，應以中華民國法為準據法。
        <br />
        <p>第十三條 [管轄法院]</p>就本協議所生之民事糾紛，雙方合意以台北地方法院為第一審管轄法院。
        <br />* 生效日期：2019年12月7日
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'policyDialog',
  components: {},

  props: ['policyVisible'],
}
</script>
